import AbstractGuestlistDetailsPageController from '../abstract-details-controller';
import guestlistModelReducer from '../../../../helpers/guestlist-model-reducer';
import askForLeavingWithoutSavingChanges
    from '../../../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';
import guestlistEditAlertHandler from '../../../../../../modules/guestlists/helpers/guestlist-edit-alert-handler';

export default class GuestlistMessageSettingsPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        askForLeavingWithoutSavingChanges(this);
        this.depositService = this.injector.get('Deposit');

        this.originalModel = true;
        this.model = null;
        this.mainRsvpSendFlows = [];
        this.submitting = false;

        this.allowRoute = true;
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        const reducedModel = guestlistModelReducer(this.guestlist, _.get(this.userStore, 'state.company', null));
        this.originalModel = {
            settings: {
                messages_main_rsvp_send_flow: _.get(reducedModel, 'settings.messages_main_rsvp_send_flow'),
                send_guest_emails: _.get(reducedModel, 'settings.send_guest_emails'),
                send_representative_emails: _.get(reducedModel, 'settings.send_representative_emails'),
                send_recommendation_emails: _.get(reducedModel, 'settings.send_recommendation_emails'),
            }
        };
        this.model = _.cloneDeep(this.originalModel);

        this.loading = true;

        this.depositService.getRemoteDeposit('guestlists', 'settings', {
            main_rsvp_send_flows: {}
        }).then((result) => {
            const mainRsvpSendFlows = [];

            _.each(result.main_rsvp_send_flows, (v, k) => {
                mainRsvpSendFlows.push({
                    value: k,
                    label: v
                });
            });

            this.mainRsvpSendFlows = mainRsvpSendFlows;
            this.loading = false;
        });
    }

    discardChanges() {
        this.model = _.cloneDeep(this.originalModel);
    }

    save() {
        this.submitting = true;
        this.api
            .put(
                `guestlists/${this.guestlist.id}/settings`,
                this.model,
                {
                    headers: {
                        'x-festzelt-os-guestlist-version-hash': this.guestlist.version_hash
                    }
                }
            )
            .then(() => {
                this._loadGuestlist();
                this.submitting = false;
            })
            .catch(e => {
                return guestlistEditAlertHandler(this.injector, e)
                    .catch((e) => {
                        this.alert.handle(e);
                    })
                    .finally(() => {
                        this.submitting = false;
                        return this._loadGuestlist();
                    });
            });
    }

    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(
            () => this.model,
            () => {
                this.dataChanged = !_.isEqual(this.model, this.originalModel);
                this.allowRoute = !this.dataChanged;
            },
            true
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/messages/settings-controller.js